import script from "./BirthSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthSheet.vue?vue&type=script&setup=true&lang=js"

import "./BirthSheet.vue?vue&type=style&index=0&id=4c84ace9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c84ace9"]])

export default __exports__